// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 stroke=%27%23888%27 stroke-width=%271.5%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════
   mobile.css — 모바일 전용 공통 스타일
   수익/양수=빨강(#e53935), 손실/음수=파랑(#1565c0) (한국 주식 관례)
   ════════════════════════════════════════════════════════════ */

:root {
  --mb-pos: #e53935;
  --mb-neg: #1565c0;
  --mb-neu: #666;
  --mb-accent: #4a6cf7;
  --mb-bg: #f4f6fb;
  --mb-card-bg: #ffffff;
  --mb-border: #e4e8f0;
  --mb-header-h: 52px;
  --mb-tabs-h: 60px;
  --mb-safe-bottom: env(safe-area-inset-bottom, 0px);
}

/* ── 기본 리셋 ─────────────────────────────────────────────── */
.mb-root {
  font-family: -apple-system, BlinkMacSystemFont, 'Noto Sans KR', sans-serif;
  font-size: 14px;
  color: #1a1a2e;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}

/* ── 레이아웃 ──────────────────────────────────────────────── */
.mb-layout {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: var(--mb-bg);
}

.mb-header {
  flex-shrink: 0;
  height: var(--mb-header-h);
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  z-index: 100;
}

.mb-header-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mb-hamburger {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  padding: 0 6px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444;
  flex-shrink: 0;
}

.mb-header-title-btn {
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 700;
  color: var(--mb-accent);
  letter-spacing: -0.3px;
  cursor: pointer;
  padding: 0;
}

/* 구버전 span 타이틀 — 하위호환용 */
.mb-header-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--mb-accent);
  letter-spacing: -0.3px;
}

.mb-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mb-header-user {
  font-size: 12px;
  color: #888;
}

.mb-content {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 12px;
}

/* ── 풀스크린 페이지 (뒤로가기 헤더) ──────────────────────── */
.mb-back-layout {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: var(--mb-bg);
}

.mb-back-header {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
  padding: 0 16px;
}

.mb-back-header-row {
  height: var(--mb-header-h);
  display: flex;
  align-items: center;
  gap: 12px;
}

.mb-back-btn {
  background: none;
  border: none;
  padding: 8px 4px 8px 0;
  font-size: 22px;
  color: var(--mb-accent);
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
}

.mb-back-header-title {
  font-size: 16px;
  font-weight: 700;
  flex: 1 1;
}

.mb-back-header-sub {
  font-size: 11px;
  color: #888;
  padding: 4px 0 8px;
  border-top: 1px solid #f0f0f0;
}

.mb-back-content {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── 하단 탭바 ─────────────────────────────────────────────── */
.mb-bottom-tabs {
  flex-shrink: 0;
  height: calc(var(--mb-tabs-h) + var(--mb-safe-bottom));
  padding-bottom: var(--mb-safe-bottom);
  background: #fff;
  border-top: 1px solid var(--mb-border);
  display: flex;
  align-items: stretch;
}

.mb-tab-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 6px 0;
  cursor: pointer;
  color: #999;
  font-size: 10px;
  gap: 3px;
  min-height: 44px;
}

.mb-tab-btn.active {
  color: var(--mb-accent);
}

.mb-tab-icon {
  font-size: 20px;
  line-height: 1;
}

.mb-tab-label {
  font-size: 10px;
  font-weight: 500;
}

/* ── 계좌 칩 ────────────────────────────────────────────────── */
.mb-chips-wrap {
  display: flex;
  gap: 3px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 7px 8px;
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
  scrollbar-width: none;
}

.mb-chips-wrap::-webkit-scrollbar {
  display: none;
}

.mb-chip {
  flex-shrink: 0;
  height: 28px;
  padding: 0 5px;
  border: 1.5px solid var(--mb-border);
  border-radius: 14px;
  background: #fff;
  font-size: 11px;
  line-height: 1;
  color: #555;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.mb-chip.active {
  background: var(--mb-accent);
  border-color: var(--mb-accent);
  color: #fff;
  font-weight: 600;
}

/* ── 기간 탭 ─────────────────────────────────────────────────── */
.mb-period-wrap {
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
}

.mb-period-tabs {
  display: flex;
  border-bottom: 1px solid var(--mb-border);
}

.mb-period-tab {
  flex: 1 1;
  height: 40px;
  background: none;
  border: none;
  border-bottom: 2.5px solid transparent;
  font-size: 13px;
  font-weight: 500;
  color: #888;
  cursor: pointer;
}

.mb-period-tab.active {
  color: var(--mb-accent);
  border-bottom-color: var(--mb-accent);
}

.mb-period-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 8px 16px;
}

.mb-nav-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--mb-border);
  border-radius: 8px;
  background: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mb-nav-btn:disabled {
  color: #ccc;
  cursor: not-allowed;
}

.mb-nav-label {
  font-size: 14px;
  font-weight: 600;
  min-width: 140px;
  text-align: center;
}

.mb-custom-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  flex-wrap: wrap;
}

.mb-custom-sel {
  flex: 1 1;
  min-width: 100px;
  height: 36px;
  border: 1px solid var(--mb-border);
  border-radius: 6px;
  padding: 0 8px;
  font-size: 13px;
  background: #fff;
}

.mb-custom-tilde {
  font-size: 16px;
  color: #666;
}

.mb-custom-btn {
  height: 36px;
  padding: 0 16px;
  background: var(--mb-accent);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.mb-custom-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* ── 섹션 ────────────────────────────────────────────────────── */
.mb-section {
  margin: 12px 12px 0;
  background: var(--mb-card-bg);
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;
}

.mb-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 8px;
}

.mb-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #444;
}

.mb-detail-link {
  font-size: 12px;
  color: var(--mb-accent);
  background: none;
  border: none;
  padding: 4px 0;
  cursor: pointer;
  min-height: 44px;
  display: flex;
  align-items: center;
}

/* ── 2x2 지표 카드 ─────────────────────────────────────────── */
.mb-metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--mb-border);
}

.mb-metric-card {
  background: var(--mb-card-bg);
  padding: 14px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mb-metric-label {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.mb-metric-value {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: -0.5px;
}

.mb-metric-value.pos { color: var(--mb-pos); }
.mb-metric-value.neg { color: var(--mb-neg); }

.mb-metric-sub {
  font-size: 11px;
  color: #999;
}

.mb-metric-exact {
  font-size: 10px;
  color: #bbb;
}

/* ── 기간별 손익 카드 스택 ──────────────────────────────────── */
.mb-period-stack {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.mb-period-op {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #999;
  padding: 2px 0;
  line-height: 1;
}

.mb-period-card {
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--mb-border);
}

.mb-period-card:last-child {
  border-bottom: none;
}

.mb-period-card.total {
  background: #f8f4ff;
}

.mb-period-card-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mb-period-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.mb-period-card-sub {
  font-size: 11px;
  color: #999;
}

.mb-period-card-right {
  text-align: right;
}

.mb-period-card-value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: -0.5px;
}

.mb-period-card-value.pos { color: var(--mb-pos); }
.mb-period-card-value.neg { color: var(--mb-neg); }
.mb-period-card-value.total-val { color: var(--mb-accent); font-size: 22px; }

.mb-period-card-rate {
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.mb-period-card-rate.pos { color: var(--mb-pos); }
.mb-period-card-rate.neg { color: var(--mb-neg); }

.mb-period-card-exact {
  font-size: 10px;
  color: #bbb;
}

/* ── 차트 영역 ─────────────────────────────────────────────── */
.mb-chart-wrap {
  padding: 0 0 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mb-chart-inner {
  min-width: 0;
}

.mb-chart-hint {
  text-align: center;
  font-size: 11px;
  color: #bbb;
  padding-bottom: 4px;
}

/* ── 상세 페이지 탭 ─────────────────────────────────────────── */
.mb-detail-tabs {
  display: flex;
  border-bottom: 1px solid var(--mb-border);
  background: #fff;
}

.mb-detail-tab {
  flex: 1 1;
  height: 44px;
  background: none;
  border: none;
  border-bottom: 2.5px solid transparent;
  font-size: 13px;
  font-weight: 500;
  color: #888;
  cursor: pointer;
}

.mb-detail-tab.active {
  color: var(--mb-accent);
  border-bottom-color: var(--mb-accent);
}

/* ── 계좌 그룹 헤더 ─────────────────────────────────────────── */
.mb-acct-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #f0f4ff;
  border-top: 1px solid var(--mb-border);
}

.mb-acct-header-name {
  font-size: 12px;
  font-weight: 700;
  color: var(--mb-accent);
}

.mb-acct-header-sub {
  font-size: 12px;
  color: #888;
}

/* ── 계좌 소계 행 ─────────────────────────────────────────────── */
.mb-subtotal-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #f8f9fb;
  border-top: 1px solid var(--mb-border);
}

.mb-subtotal-label {
  font-size: 13px;
  color: #888;
}

.mb-subtotal-profit {
  font-size: 15px;
  font-weight: 700;
}

/* ── 종목 리스트 아이템 ─────────────────────────────────────── */
.mb-stock-item {
  display: flex;
  align-items: center;
  padding: 11px 14px;
  border-bottom: 1px solid #f4f4f4;
  min-height: 56px;
  background: #fff;
}

.mb-stock-item-left {
  flex: 1 1;
  min-width: 0;
}

.mb-stock-name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mb-stock-meta {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
}

.mb-stock-item-right {
  text-align: right;
  flex-shrink: 0;
  padding-left: 8px;
}

.mb-stock-profit {
  font-size: 15px;
  font-weight: 700;
}

.mb-stock-rate {
  font-size: 11px;
  margin-top: 1px;
}

/* ── 색상 유틸 ─────────────────────────────────────────────── */
.pos { color: var(--mb-pos); }
.neg { color: var(--mb-neg); }
.neu { color: var(--mb-neu); }
.pos-bg { background: #fff5f5; }
.neg-bg { background: #f0f4ff; }

/* ── 공통 ────────────────────────────────────────────────────── */
.mb-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: #999;
  font-size: 13px;
}

.mb-empty {
  text-align: center;
  padding: 32px 16px;
  color: #bbb;
  font-size: 13px;
}

.mb-refresh-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--mb-border);
  border-radius: 8px;
  background: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s;
}

.mb-refresh-btn.spinning {
  animation: mbSpin 0.8s linear infinite;
}

@keyframes mbSpin {
  to { transform: rotate(360deg); }
}

.mb-coming-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  color: #bbb;
}

.mb-coming-soon-icon {
  font-size: 48px;
}

.mb-coming-soon-text {
  font-size: 16px;
  font-weight: 600;
}

.mb-coming-soon-sub {
  font-size: 13px;
}

/* ── 기간 총수익 구분선 ─────────────────────────────────────── */
.mb-period-divider {
  border: none;
  border-top: 2px dashed var(--mb-border);
  margin: 0;
}

/* ── 햄버거 드로어 ─────────────────────────────────────────── */
.mb-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 200;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}
.mb-drawer-overlay.open {
  opacity: 1;
  pointer-events: all;
}

.mb-drawer-panel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 260px;
  background: #fff;
  z-index: 201;
  transform: translateX(-100%);
  transition: transform 0.25s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);
}
.mb-drawer-panel.open {
  transform: translateX(0);
}

.mb-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: var(--mb-header-h);
  border-bottom: 1px solid var(--mb-border);
  flex-shrink: 0;
}

.mb-drawer-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--mb-accent);
  letter-spacing: -0.3px;
}

.mb-drawer-close {
  background: none;
  border: none;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  padding: 8px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mb-drawer-menu {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 0;
}

.mb-drawer-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  min-height: 52px;
  transition: background 0.15s;
}
.mb-drawer-item:active {
  background: #f4f6fb;
}
.mb-drawer-item.active {
  color: var(--mb-accent);
  background: #eef1ff;
  font-weight: 700;
}

.mb-drawer-item-icon {
  font-size: 20px;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}

.mb-drawer-item-label {
  flex: 1 1;
}

.mb-drawer-divider {
  margin: 8px 0;
  border-top: 1px solid var(--mb-border);
}

.mb-drawer-item-logout {
  color: #999;
}
.mb-drawer-item-logout:active {
  background: #fff5f5;
}

/* ═══════════════════════════════════════════════════════════
   차수별현황 (TurnStatusPage)
   ════════════════════════════════════════════════════════ */

/* 표시 모드 칩 + 재집계 버튼 행 */
.ts-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px;
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
  gap: 8px;
  flex-shrink: 0;
}

.ts-mode-chips {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  flex: 1 1;
}
.ts-mode-chips::-webkit-scrollbar { display: none; }

/* 테이블 래퍼 — 가로 스크롤, 세로 스크롤은 mb-content에 위임 */
.ts-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}
.ts-table-wrap::-webkit-scrollbar        { height: 3px; }
.ts-table-wrap::-webkit-scrollbar-thumb  { background: #ccc; border-radius: 2px; }

/* 테이블 본체 */
.ts-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

/* 헤더 셀 — 세로 스크롤 시 상단 고정 (mb-content overflow-y:auto 기준) */
.ts-th {
  position: sticky;
  top: 0;
  background: #eef2ff;
  border-bottom: 1.5px solid var(--mb-border);
  border-right: 0.5px solid #d0d8f0;
  padding: 7px 5px;
  font-size: 10px;
  font-weight: 700;
  color: #3a4cad;
  white-space: nowrap;
  z-index: 10;
}

/* 종목/계좌 헤더 — 좌측 + 상단 고정 */
.ts-th-name {
  position: sticky;
  left: 0;
  z-index: 20;
  min-width: 108px;
  text-align: left;
  padding-left: 10px;
  border-right: 1px solid var(--mb-border);
}

.ts-th-r    { text-align: right; min-width: 42px; }
.ts-th-sep  { border-right: 1.5px solid #bbb; }
.ts-th-turn { text-align: center; min-width: 42px; }

/* 행 */
.ts-row         { border-bottom: 0.5px solid var(--mb-border); background: #fff; }
.ts-row-even    { background: #f9fafc; }

/* 바디 셀 공통 */
.ts-td {
  padding: 6px 5px;
  vertical-align: middle;
  white-space: nowrap;
  border-right: 0.5px solid #eee;
}

/* 종목명/계좌 셀 — 가로 스크롤 시 좌측 고정 */
.ts-td-name {
  position: sticky;
  left: 0;
  z-index: 5;
  background: inherit;
  min-width: 108px;
  max-width: 108px;
  padding-left: 10px;
  padding-right: 6px;
  border-right: 1px solid var(--mb-border);
}

.ts-stock-name {
  font-size: 12px;
  font-weight: 500;
  color: #1a1a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 96px;
}

.ts-stock-sub {
  font-size: 10px;
  color: #999;
  margin-top: 1px;
}

.ts-td-r   { text-align: right; }
.ts-td-sep { border-right: 1.5px solid #bbb; }

/* 차수 셀 */
.ts-td-turn {
  text-align: center;
  min-width: 42px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.08);
  -webkit-user-select: none;
          user-select: none;
}

/* 행 탭 효과 */
.ts-row-tap {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: rgba(74, 108, 247, 0.08);
}
.ts-row-tap:active td {
  background: #eef2ff !important;
}

/* ═══════════════════════════════════════════════════════════
   시세 그래프 (StockChartPage)
   ════════════════════════════════════════════════════════ */

.sc-period-wrap {
  display: flex;
  gap: 4px;
  padding: 8px 10px;
  background: #fff;
  border-bottom: 1px solid var(--mb-border);
  overflow-x: auto;
  scrollbar-width: none;
  flex-shrink: 0;
}
.sc-period-wrap::-webkit-scrollbar { display: none; }

/* 차트 카드 */
.sc-chart-card {
  margin: 10px 10px 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;
}

/* 범례 */
.sc-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  padding: 8px 14px 12px;
  border-top: 1px solid #f4f4f4;
}

.sc-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #555;
}

.sc-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* 요약 테이블 카드 */
.sc-summary-card {
  margin: 10px 10px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  overflow: hidden;
}

.sc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.sc-table th {
  background: #eef2ff;
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 700;
  color: #3a4cad;
  border-bottom: 1.5px solid var(--mb-border);
  white-space: nowrap;
}

.sc-table td {
  padding: 8px 10px;
  border-bottom: 0.5px solid #f2f2f2;
  white-space: nowrap;
  color: #1a1a2e;
}

.sc-table tbody tr:last-child td {
  border-bottom: none;
}

/* ══════════════════════════════════════════════════════════
   토스트 메시지 (공통)
   ══════════════════════════════════════════════════════ */
.mb-toast {
  position: fixed;
  bottom: calc(var(--mb-tabs-h) + var(--mb-safe-bottom) + 16px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(30, 30, 30, 0.85);
  color: #fff;
  padding: 9px 22px;
  border-radius: 20px;
  font-size: 13px;
  z-index: 300;
  pointer-events: none;
  white-space: nowrap;
}

/* ══════════════════════════════════════════════════════════
   QuickTrade — 빠른 매수/매도 등록
   ══════════════════════════════════════════════════════ */

.qt-wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

/* ── 매수/매도 탭 ── */
.qt-tabs {
  display: flex;
  border-bottom: 2px solid var(--mb-border);
  background: #fff;
  flex-shrink: 0;
}

.qt-tab-btn {
  flex: 1 1;
  height: 48px;
  border: none;
  background: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
  color: #aaa;
}

.qt-tab-buy.qt-tab-active {
  color: #1565c0;
  border-bottom-color: #1565c0;
}

.qt-tab-sell.qt-tab-active {
  color: #c62828;
  border-bottom-color: #c62828;
}

/* ── 폼 영역 ── */
.qt-form {
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── 개별 필드 ── */
.qt-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.qt-label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.qt-req {
  color: #e53935;
  font-size: 13px;
}

.qt-input,
.qt-select {
  height: 48px;
  border: 1.5px solid #d8dce8;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 15px;
  background: #fff;
  color: #1a1a2e;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
}

.qt-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;
}

.qt-input:focus,
.qt-select:focus {
  border-color: var(--mb-accent);
}

.qt-input-num {
  text-align: right;
}

/* ── 읽기전용 값 표시 ── */
.qt-readonly {
  height: 48px;
  border: 1.5px solid #eee;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 15px;
  background: #f8f9fc;
  color: #555;
  display: flex;
  align-items: center;
}

.qt-amount {
  font-weight: 700;
  color: #1a1a2e;
  font-size: 16px;
  justify-content: flex-end;
}

/* ── 선택된 종목 ── */
.qt-selected-stock {
  height: 48px;
  border: 1.5px solid var(--mb-accent);
  border-radius: 8px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0f3ff;
}

.qt-sel-name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qt-sel-ticker {
  font-size: 11px;
  color: #888;
  font-family: monospace;
  flex-shrink: 0;
}

.qt-clear-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #aaa;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  flex-shrink: 0;
  min-width: 28px;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── 종목 검색 드롭다운 ── */
.qt-search-wrap {
  position: relative;
}

.qt-stock-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0; right: 0;
  background: #fff;
  border: 1.5px solid #d8dce8;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 220px;
  overflow-y: auto;
  z-index: 200;
  -webkit-overflow-scrolling: touch;
}

.qt-stock-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: none;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  text-align: left;
  gap: 8px;
}

.qt-stock-item:last-child {
  border-bottom: none;
}

.qt-stock-item:active {
  background: #f0f3ff;
}

.qt-si-name {
  font-size: 14px;
  color: #1a1a2e;
  flex: 1 1;
  text-align: left;
}

.qt-si-ticker {
  font-size: 11px;
  color: #999;
  font-family: monospace;
  flex-shrink: 0;
}

.qt-list-empty {
  padding: 16px;
  text-align: center;
  color: #bbb;
  font-size: 13px;
}

/* ── 차수 선택 ── */
.qt-turn-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qt-turn-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1.5px solid #d8dce8;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: all 0.12s;
}

.qt-turn-item.qt-turn-sel {
  border-color: #c62828;
  background: #fff5f5;
}

.qt-turn-no {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  width: 32px;
  flex-shrink: 0;
}

.qt-turn-item.qt-turn-sel .qt-turn-no {
  color: #c62828;
}

.qt-turn-detail {
  font-size: 12px;
  color: #888;
  flex: 1 1;
}

/* ── 매수 참고 정보 박스 ── */
.qt-ref-box {
  background: #f4f6fb;
  border: 1px solid #e0e4f0;
  border-radius: 8px;
  padding: 12px 14px;
}

.qt-ref-title {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.qt-ref-grid {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 5px 8px;
}

.qt-ref-k {
  font-size: 12px;
  color: #999;
}

.qt-ref-v {
  font-size: 12px;
  color: #1a1a2e;
  font-weight: 600;
  text-align: right;
}

/* ── 매도금액/손익 계산 박스 ── */
.qt-calc-box {
  background: #f8f9fc;
  border: 1px solid #e4e8f0;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qt-calc-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qt-calc-k {
  font-size: 13px;
  color: #888;
}

.qt-calc-v {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
}

.qt-profit {
  font-size: 16px;
}

/* ── 안내 텍스트 ── */
.qt-placeholder-hint {
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
}

/* ── 등록 버튼 ── */
.qt-submit {
  height: 52px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 6px;
  transition: opacity 0.15s;
}

.qt-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.qt-submit-buy {
  background: #1565c0;
  color: #fff;
}

.qt-submit-buy:not(:disabled):active {
  background: #0d47a1;
}

.qt-submit-sell {
  background: #c62828;
  color: #fff;
}

.qt-submit-sell:not(:disabled):active {
  background: #b71c1c;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/styles/mobile.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA,6DAA6D;AAC7D;EACE,0EAA0E;EAC1E,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,sDAAsD;EACtD,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,uBAAuB,oBAAoB,EAAE;AAC7C,uBAAuB,oBAAoB,EAAE;;AAE7C;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,4BAA4B,oBAAoB,EAAE;AAClD,4BAA4B,oBAAoB,EAAE;AAClD,kCAAkC,uBAAuB,EAAE,eAAe,EAAE;;AAE5E;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,2BAA2B,oBAAoB,EAAE;AACjD,2BAA2B,oBAAoB,EAAE;;AAEjD;EACE,eAAe;EACf,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,6DAA6D;AAC7D,OAAO,oBAAoB,EAAE;AAC7B,OAAO,oBAAoB,EAAE;AAC7B,OAAO,oBAAoB,EAAE;AAC7B,UAAU,mBAAmB,EAAE;AAC/B,UAAU,mBAAmB,EAAE;;AAE/B,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,uCAAuC;EACvC,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;;6DAE6D;;AAE7D,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;AACA,oCAAoC,aAAa,EAAE;;AAEnD,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,iCAAiC;AACnC;AACA,2CAA2C,WAAW,EAAE;AACxD,2CAA2C,gBAAgB,EAAE,kBAAkB,EAAE;;AAEjF,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,cAAc,iBAAiB,EAAE,eAAe,EAAE;AAClD,cAAc,8BAA8B,EAAE;AAC9C,cAAc,kBAAkB,EAAE,eAAe,EAAE;;AAEnD,MAAM;AACN,kBAAkB,2CAA2C,EAAE,gBAAgB,EAAE;AACjF,kBAAkB,mBAAmB,EAAE;;AAEvC,YAAY;AACZ;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,aAAa,iBAAiB,EAAE;AAChC,aAAa,8BAA8B,EAAE;;AAE7C,SAAS;AACT;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;;AAEA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA,qCAAqC,aAAa,EAAE;;AAEpD,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;2DAE2D;AAC3D;EACE,eAAe;EACf,6DAA6D;EAC7D,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;2DAE2D;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,yDAAsN;EACtN,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO,EAAE,QAAQ;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ════════════════════════════════════════════════════════════\n   mobile.css — 모바일 전용 공통 스타일\n   수익/양수=빨강(#e53935), 손실/음수=파랑(#1565c0) (한국 주식 관례)\n   ════════════════════════════════════════════════════════════ */\n\n:root {\n  --mb-pos: #e53935;\n  --mb-neg: #1565c0;\n  --mb-neu: #666;\n  --mb-accent: #4a6cf7;\n  --mb-bg: #f4f6fb;\n  --mb-card-bg: #ffffff;\n  --mb-border: #e4e8f0;\n  --mb-header-h: 52px;\n  --mb-tabs-h: 60px;\n  --mb-safe-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n/* ── 기본 리셋 ─────────────────────────────────────────────── */\n.mb-root {\n  font-family: -apple-system, BlinkMacSystemFont, 'Noto Sans KR', sans-serif;\n  font-size: 14px;\n  color: #1a1a2e;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ── 레이아웃 ──────────────────────────────────────────────── */\n.mb-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  background: var(--mb-bg);\n}\n\n.mb-header {\n  flex-shrink: 0;\n  height: var(--mb-header-h);\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  position: relative;\n  z-index: 100;\n}\n\n.mb-header-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mb-hamburger {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 0 6px;\n  min-width: 40px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #444;\n  flex-shrink: 0;\n}\n\n.mb-header-title-btn {\n  background: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--mb-accent);\n  letter-spacing: -0.3px;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* 구버전 span 타이틀 — 하위호환용 */\n.mb-header-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--mb-accent);\n  letter-spacing: -0.3px;\n}\n\n.mb-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mb-header-user {\n  font-size: 12px;\n  color: #888;\n}\n\n.mb-content {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 12px;\n}\n\n/* ── 풀스크린 페이지 (뒤로가기 헤더) ──────────────────────── */\n.mb-back-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  background: var(--mb-bg);\n}\n\n.mb-back-header {\n  flex-shrink: 0;\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n  padding: 0 16px;\n}\n\n.mb-back-header-row {\n  height: var(--mb-header-h);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mb-back-btn {\n  background: none;\n  border: none;\n  padding: 8px 4px 8px 0;\n  font-size: 22px;\n  color: var(--mb-accent);\n  cursor: pointer;\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n.mb-back-header-title {\n  font-size: 16px;\n  font-weight: 700;\n  flex: 1;\n}\n\n.mb-back-header-sub {\n  font-size: 11px;\n  color: #888;\n  padding: 4px 0 8px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.mb-back-content {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ── 하단 탭바 ─────────────────────────────────────────────── */\n.mb-bottom-tabs {\n  flex-shrink: 0;\n  height: calc(var(--mb-tabs-h) + var(--mb-safe-bottom));\n  padding-bottom: var(--mb-safe-bottom);\n  background: #fff;\n  border-top: 1px solid var(--mb-border);\n  display: flex;\n  align-items: stretch;\n}\n\n.mb-tab-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 6px 0;\n  cursor: pointer;\n  color: #999;\n  font-size: 10px;\n  gap: 3px;\n  min-height: 44px;\n}\n\n.mb-tab-btn.active {\n  color: var(--mb-accent);\n}\n\n.mb-tab-icon {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.mb-tab-label {\n  font-size: 10px;\n  font-weight: 500;\n}\n\n/* ── 계좌 칩 ────────────────────────────────────────────────── */\n.mb-chips-wrap {\n  display: flex;\n  gap: 3px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 7px 8px;\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n  scrollbar-width: none;\n}\n\n.mb-chips-wrap::-webkit-scrollbar {\n  display: none;\n}\n\n.mb-chip {\n  flex-shrink: 0;\n  height: 28px;\n  padding: 0 5px;\n  border: 1.5px solid var(--mb-border);\n  border-radius: 14px;\n  background: #fff;\n  font-size: 11px;\n  line-height: 1;\n  color: #555;\n  cursor: pointer;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.mb-chip.active {\n  background: var(--mb-accent);\n  border-color: var(--mb-accent);\n  color: #fff;\n  font-weight: 600;\n}\n\n/* ── 기간 탭 ─────────────────────────────────────────────────── */\n.mb-period-wrap {\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n}\n\n.mb-period-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--mb-border);\n}\n\n.mb-period-tab {\n  flex: 1;\n  height: 40px;\n  background: none;\n  border: none;\n  border-bottom: 2.5px solid transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #888;\n  cursor: pointer;\n}\n\n.mb-period-tab.active {\n  color: var(--mb-accent);\n  border-bottom-color: var(--mb-accent);\n}\n\n.mb-period-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 8px 16px;\n}\n\n.mb-nav-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--mb-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mb-nav-btn:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.mb-nav-label {\n  font-size: 14px;\n  font-weight: 600;\n  min-width: 140px;\n  text-align: center;\n}\n\n.mb-custom-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  flex-wrap: wrap;\n}\n\n.mb-custom-sel {\n  flex: 1;\n  min-width: 100px;\n  height: 36px;\n  border: 1px solid var(--mb-border);\n  border-radius: 6px;\n  padding: 0 8px;\n  font-size: 13px;\n  background: #fff;\n}\n\n.mb-custom-tilde {\n  font-size: 16px;\n  color: #666;\n}\n\n.mb-custom-btn {\n  height: 36px;\n  padding: 0 16px;\n  background: var(--mb-accent);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.mb-custom-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* ── 섹션 ────────────────────────────────────────────────────── */\n.mb-section {\n  margin: 12px 12px 0;\n  background: var(--mb-card-bg);\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;\n}\n\n.mb-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px 8px;\n}\n\n.mb-section-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #444;\n}\n\n.mb-detail-link {\n  font-size: 12px;\n  color: var(--mb-accent);\n  background: none;\n  border: none;\n  padding: 4px 0;\n  cursor: pointer;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n/* ── 2x2 지표 카드 ─────────────────────────────────────────── */\n.mb-metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1px;\n  background: var(--mb-border);\n}\n\n.mb-metric-card {\n  background: var(--mb-card-bg);\n  padding: 14px;\n  min-height: 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mb-metric-label {\n  font-size: 11px;\n  color: #888;\n  font-weight: 500;\n}\n\n.mb-metric-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a1a2e;\n  letter-spacing: -0.5px;\n}\n\n.mb-metric-value.pos { color: var(--mb-pos); }\n.mb-metric-value.neg { color: var(--mb-neg); }\n\n.mb-metric-sub {\n  font-size: 11px;\n  color: #999;\n}\n\n.mb-metric-exact {\n  font-size: 10px;\n  color: #bbb;\n}\n\n/* ── 기간별 손익 카드 스택 ──────────────────────────────────── */\n.mb-period-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.mb-period-op {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: #999;\n  padding: 2px 0;\n  line-height: 1;\n}\n\n.mb-period-card {\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--mb-border);\n}\n\n.mb-period-card:last-child {\n  border-bottom: none;\n}\n\n.mb-period-card.total {\n  background: #f8f4ff;\n}\n\n.mb-period-card-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mb-period-card-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.mb-period-card-sub {\n  font-size: 11px;\n  color: #999;\n}\n\n.mb-period-card-right {\n  text-align: right;\n}\n\n.mb-period-card-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a2e;\n  letter-spacing: -0.5px;\n}\n\n.mb-period-card-value.pos { color: var(--mb-pos); }\n.mb-period-card-value.neg { color: var(--mb-neg); }\n.mb-period-card-value.total-val { color: var(--mb-accent); font-size: 22px; }\n\n.mb-period-card-rate {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n}\n\n.mb-period-card-rate.pos { color: var(--mb-pos); }\n.mb-period-card-rate.neg { color: var(--mb-neg); }\n\n.mb-period-card-exact {\n  font-size: 10px;\n  color: #bbb;\n}\n\n/* ── 차트 영역 ─────────────────────────────────────────────── */\n.mb-chart-wrap {\n  padding: 0 0 4px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mb-chart-inner {\n  min-width: 0;\n}\n\n.mb-chart-hint {\n  text-align: center;\n  font-size: 11px;\n  color: #bbb;\n  padding-bottom: 4px;\n}\n\n/* ── 상세 페이지 탭 ─────────────────────────────────────────── */\n.mb-detail-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--mb-border);\n  background: #fff;\n}\n\n.mb-detail-tab {\n  flex: 1;\n  height: 44px;\n  background: none;\n  border: none;\n  border-bottom: 2.5px solid transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #888;\n  cursor: pointer;\n}\n\n.mb-detail-tab.active {\n  color: var(--mb-accent);\n  border-bottom-color: var(--mb-accent);\n}\n\n/* ── 계좌 그룹 헤더 ─────────────────────────────────────────── */\n.mb-acct-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  background: #f0f4ff;\n  border-top: 1px solid var(--mb-border);\n}\n\n.mb-acct-header-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--mb-accent);\n}\n\n.mb-acct-header-sub {\n  font-size: 12px;\n  color: #888;\n}\n\n/* ── 계좌 소계 행 ─────────────────────────────────────────────── */\n.mb-subtotal-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  background: #f8f9fb;\n  border-top: 1px solid var(--mb-border);\n}\n\n.mb-subtotal-label {\n  font-size: 13px;\n  color: #888;\n}\n\n.mb-subtotal-profit {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n/* ── 종목 리스트 아이템 ─────────────────────────────────────── */\n.mb-stock-item {\n  display: flex;\n  align-items: center;\n  padding: 11px 14px;\n  border-bottom: 1px solid #f4f4f4;\n  min-height: 56px;\n  background: #fff;\n}\n\n.mb-stock-item-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.mb-stock-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mb-stock-meta {\n  font-size: 11px;\n  color: #999;\n  margin-top: 2px;\n}\n\n.mb-stock-item-right {\n  text-align: right;\n  flex-shrink: 0;\n  padding-left: 8px;\n}\n\n.mb-stock-profit {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.mb-stock-rate {\n  font-size: 11px;\n  margin-top: 1px;\n}\n\n/* ── 색상 유틸 ─────────────────────────────────────────────── */\n.pos { color: var(--mb-pos); }\n.neg { color: var(--mb-neg); }\n.neu { color: var(--mb-neu); }\n.pos-bg { background: #fff5f5; }\n.neg-bg { background: #f0f4ff; }\n\n/* ── 공통 ────────────────────────────────────────────────────── */\n.mb-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  color: #999;\n  font-size: 13px;\n}\n\n.mb-empty {\n  text-align: center;\n  padding: 32px 16px;\n  color: #bbb;\n  font-size: 13px;\n}\n\n.mb-refresh-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--mb-border);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.5s;\n}\n\n.mb-refresh-btn.spinning {\n  animation: mbSpin 0.8s linear infinite;\n}\n\n@keyframes mbSpin {\n  to { transform: rotate(360deg); }\n}\n\n.mb-coming-soon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 12px;\n  color: #bbb;\n}\n\n.mb-coming-soon-icon {\n  font-size: 48px;\n}\n\n.mb-coming-soon-text {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.mb-coming-soon-sub {\n  font-size: 13px;\n}\n\n/* ── 기간 총수익 구분선 ─────────────────────────────────────── */\n.mb-period-divider {\n  border: none;\n  border-top: 2px dashed var(--mb-border);\n  margin: 0;\n}\n\n/* ── 햄버거 드로어 ─────────────────────────────────────────── */\n.mb-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 200;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.25s ease;\n}\n.mb-drawer-overlay.open {\n  opacity: 1;\n  pointer-events: all;\n}\n\n.mb-drawer-panel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 260px;\n  background: #fff;\n  z-index: 201;\n  transform: translateX(-100%);\n  transition: transform 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);\n}\n.mb-drawer-panel.open {\n  transform: translateX(0);\n}\n\n.mb-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  height: var(--mb-header-h);\n  border-bottom: 1px solid var(--mb-border);\n  flex-shrink: 0;\n}\n\n.mb-drawer-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--mb-accent);\n  letter-spacing: -0.3px;\n}\n\n.mb-drawer-close {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #888;\n  cursor: pointer;\n  padding: 8px;\n  min-width: 40px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mb-drawer-menu {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.mb-drawer-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 20px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  color: #333;\n  font-size: 14px;\n  font-weight: 500;\n  min-height: 52px;\n  transition: background 0.15s;\n}\n.mb-drawer-item:active {\n  background: #f4f6fb;\n}\n.mb-drawer-item.active {\n  color: var(--mb-accent);\n  background: #eef1ff;\n  font-weight: 700;\n}\n\n.mb-drawer-item-icon {\n  font-size: 20px;\n  width: 28px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.mb-drawer-item-label {\n  flex: 1;\n}\n\n.mb-drawer-divider {\n  margin: 8px 0;\n  border-top: 1px solid var(--mb-border);\n}\n\n.mb-drawer-item-logout {\n  color: #999;\n}\n.mb-drawer-item-logout:active {\n  background: #fff5f5;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   차수별현황 (TurnStatusPage)\n   ════════════════════════════════════════════════════════ */\n\n/* 표시 모드 칩 + 재집계 버튼 행 */\n.ts-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 8px;\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.ts-mode-chips {\n  display: flex;\n  gap: 4px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  flex: 1;\n}\n.ts-mode-chips::-webkit-scrollbar { display: none; }\n\n/* 테이블 래퍼 — 가로 스크롤, 세로 스크롤은 mb-content에 위임 */\n.ts-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #ccc transparent;\n}\n.ts-table-wrap::-webkit-scrollbar        { height: 3px; }\n.ts-table-wrap::-webkit-scrollbar-thumb  { background: #ccc; border-radius: 2px; }\n\n/* 테이블 본체 */\n.ts-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n}\n\n/* 헤더 셀 — 세로 스크롤 시 상단 고정 (mb-content overflow-y:auto 기준) */\n.ts-th {\n  position: sticky;\n  top: 0;\n  background: #eef2ff;\n  border-bottom: 1.5px solid var(--mb-border);\n  border-right: 0.5px solid #d0d8f0;\n  padding: 7px 5px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #3a4cad;\n  white-space: nowrap;\n  z-index: 10;\n}\n\n/* 종목/계좌 헤더 — 좌측 + 상단 고정 */\n.ts-th-name {\n  position: sticky;\n  left: 0;\n  z-index: 20;\n  min-width: 108px;\n  text-align: left;\n  padding-left: 10px;\n  border-right: 1px solid var(--mb-border);\n}\n\n.ts-th-r    { text-align: right; min-width: 42px; }\n.ts-th-sep  { border-right: 1.5px solid #bbb; }\n.ts-th-turn { text-align: center; min-width: 42px; }\n\n/* 행 */\n.ts-row         { border-bottom: 0.5px solid var(--mb-border); background: #fff; }\n.ts-row-even    { background: #f9fafc; }\n\n/* 바디 셀 공통 */\n.ts-td {\n  padding: 6px 5px;\n  vertical-align: middle;\n  white-space: nowrap;\n  border-right: 0.5px solid #eee;\n}\n\n/* 종목명/계좌 셀 — 가로 스크롤 시 좌측 고정 */\n.ts-td-name {\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  background: inherit;\n  min-width: 108px;\n  max-width: 108px;\n  padding-left: 10px;\n  padding-right: 6px;\n  border-right: 1px solid var(--mb-border);\n}\n\n.ts-stock-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #1a1a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 96px;\n}\n\n.ts-stock-sub {\n  font-size: 10px;\n  color: #999;\n  margin-top: 1px;\n}\n\n.ts-td-r   { text-align: right; }\n.ts-td-sep { border-right: 1.5px solid #bbb; }\n\n/* 차수 셀 */\n.ts-td-turn {\n  text-align: center;\n  min-width: 42px;\n  font-weight: 600;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.08);\n  user-select: none;\n}\n\n/* 행 탭 효과 */\n.ts-row-tap {\n  cursor: pointer;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(74, 108, 247, 0.08);\n}\n.ts-row-tap:active td {\n  background: #eef2ff !important;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   시세 그래프 (StockChartPage)\n   ════════════════════════════════════════════════════════ */\n\n.sc-period-wrap {\n  display: flex;\n  gap: 4px;\n  padding: 8px 10px;\n  background: #fff;\n  border-bottom: 1px solid var(--mb-border);\n  overflow-x: auto;\n  scrollbar-width: none;\n  flex-shrink: 0;\n}\n.sc-period-wrap::-webkit-scrollbar { display: none; }\n\n/* 차트 카드 */\n.sc-chart-card {\n  margin: 10px 10px 0;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;\n}\n\n/* 범례 */\n.sc-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  padding: 8px 14px 12px;\n  border-top: 1px solid #f4f4f4;\n}\n\n.sc-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #555;\n}\n\n.sc-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* 요약 테이블 카드 */\n.sc-summary-card {\n  margin: 10px 10px 16px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.07);\n  overflow: hidden;\n}\n\n.sc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.sc-table th {\n  background: #eef2ff;\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #3a4cad;\n  border-bottom: 1.5px solid var(--mb-border);\n  white-space: nowrap;\n}\n\n.sc-table td {\n  padding: 8px 10px;\n  border-bottom: 0.5px solid #f2f2f2;\n  white-space: nowrap;\n  color: #1a1a2e;\n}\n\n.sc-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ══════════════════════════════════════════════════════════\n   토스트 메시지 (공통)\n   ══════════════════════════════════════════════════════ */\n.mb-toast {\n  position: fixed;\n  bottom: calc(var(--mb-tabs-h) + var(--mb-safe-bottom) + 16px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(30, 30, 30, 0.85);\n  color: #fff;\n  padding: 9px 22px;\n  border-radius: 20px;\n  font-size: 13px;\n  z-index: 300;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n/* ══════════════════════════════════════════════════════════\n   QuickTrade — 빠른 매수/매도 등록\n   ══════════════════════════════════════════════════════ */\n\n.qt-wrap {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n/* ── 매수/매도 탭 ── */\n.qt-tabs {\n  display: flex;\n  border-bottom: 2px solid var(--mb-border);\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.qt-tab-btn {\n  flex: 1;\n  height: 48px;\n  border: none;\n  background: none;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.15s;\n  color: #aaa;\n}\n\n.qt-tab-buy.qt-tab-active {\n  color: #1565c0;\n  border-bottom-color: #1565c0;\n}\n\n.qt-tab-sell.qt-tab-active {\n  color: #c62828;\n  border-bottom-color: #c62828;\n}\n\n/* ── 폼 영역 ── */\n.qt-form {\n  padding: 16px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── 개별 필드 ── */\n.qt-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.qt-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n}\n\n.qt-req {\n  color: #e53935;\n  font-size: 13px;\n}\n\n.qt-input,\n.qt-select {\n  height: 48px;\n  border: 1.5px solid #d8dce8;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 15px;\n  background: #fff;\n  color: #1a1a2e;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.qt-select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23888' stroke-width='1.5' fill='none'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 32px;\n}\n\n.qt-input:focus,\n.qt-select:focus {\n  border-color: var(--mb-accent);\n}\n\n.qt-input-num {\n  text-align: right;\n}\n\n/* ── 읽기전용 값 표시 ── */\n.qt-readonly {\n  height: 48px;\n  border: 1.5px solid #eee;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 15px;\n  background: #f8f9fc;\n  color: #555;\n  display: flex;\n  align-items: center;\n}\n\n.qt-amount {\n  font-weight: 700;\n  color: #1a1a2e;\n  font-size: 16px;\n  justify-content: flex-end;\n}\n\n/* ── 선택된 종목 ── */\n.qt-selected-stock {\n  height: 48px;\n  border: 1.5px solid var(--mb-accent);\n  border-radius: 8px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f0f3ff;\n}\n\n.qt-sel-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qt-sel-ticker {\n  font-size: 11px;\n  color: #888;\n  font-family: monospace;\n  flex-shrink: 0;\n}\n\n.qt-clear-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #aaa;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  flex-shrink: 0;\n  min-width: 28px;\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ── 종목 검색 드롭다운 ── */\n.qt-search-wrap {\n  position: relative;\n}\n\n.qt-stock-list {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0; right: 0;\n  background: #fff;\n  border: 1.5px solid #d8dce8;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  max-height: 220px;\n  overflow-y: auto;\n  z-index: 200;\n  -webkit-overflow-scrolling: touch;\n}\n\n.qt-stock-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  text-align: left;\n  gap: 8px;\n}\n\n.qt-stock-item:last-child {\n  border-bottom: none;\n}\n\n.qt-stock-item:active {\n  background: #f0f3ff;\n}\n\n.qt-si-name {\n  font-size: 14px;\n  color: #1a1a2e;\n  flex: 1;\n  text-align: left;\n}\n\n.qt-si-ticker {\n  font-size: 11px;\n  color: #999;\n  font-family: monospace;\n  flex-shrink: 0;\n}\n\n.qt-list-empty {\n  padding: 16px;\n  text-align: center;\n  color: #bbb;\n  font-size: 13px;\n}\n\n/* ── 차수 선택 ── */\n.qt-turn-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.qt-turn-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1.5px solid #d8dce8;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.12s;\n}\n\n.qt-turn-item.qt-turn-sel {\n  border-color: #c62828;\n  background: #fff5f5;\n}\n\n.qt-turn-no {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a2e;\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.qt-turn-item.qt-turn-sel .qt-turn-no {\n  color: #c62828;\n}\n\n.qt-turn-detail {\n  font-size: 12px;\n  color: #888;\n  flex: 1;\n}\n\n/* ── 매수 참고 정보 박스 ── */\n.qt-ref-box {\n  background: #f4f6fb;\n  border: 1px solid #e0e4f0;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.qt-ref-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #888;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.qt-ref-grid {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 5px 8px;\n}\n\n.qt-ref-k {\n  font-size: 12px;\n  color: #999;\n}\n\n.qt-ref-v {\n  font-size: 12px;\n  color: #1a1a2e;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* ── 매도금액/손익 계산 박스 ── */\n.qt-calc-box {\n  background: #f8f9fc;\n  border: 1px solid #e4e8f0;\n  border-radius: 8px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.qt-calc-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.qt-calc-k {\n  font-size: 13px;\n  color: #888;\n}\n\n.qt-calc-v {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.qt-profit {\n  font-size: 16px;\n}\n\n/* ── 안내 텍스트 ── */\n.qt-placeholder-hint {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #bbb;\n}\n\n/* ── 등록 버튼 ── */\n.qt-submit {\n  height: 52px;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 6px;\n  transition: opacity 0.15s;\n}\n\n.qt-submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.qt-submit-buy {\n  background: #1565c0;\n  color: #fff;\n}\n\n.qt-submit-buy:not(:disabled):active {\n  background: #0d47a1;\n}\n\n.qt-submit-sell {\n  background: #c62828;\n  color: #fff;\n}\n\n.qt-submit-sell:not(:disabled):active {\n  background: #b71c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
